import { Link } from '@inertiajs/react';
import classNames from 'classnames';
import { Code, Compass, Heart, Home, Settings, Users } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { Icon } from '../../Shared/UI/Icon';
import { useRouter } from '../router';

export function MainNav({
  charity,
  segment = null,
}: {
  charity: { public: boolean; onboarding: boolean; };
  /** Active URL segment (/b/{projectId}/{segment}) */
  segment?: string | null;
}) {
  const { t } = useTranslation();
  const { routes } = useRouter();

  const getClassNames = (name: string) => classNames(
    'text-white hover:text-white font-medium inline-block leading-5 py-3 px-3 text-[15px] rounded-md hover:bg-blue-700/50 transition',
    name === segment && '!bg-blue-700',
  );

  return (
    <div className="space-x-1 text-center">
      {charity.onboarding && (
        <Link href={routes.onboarding_page()} className={getClassNames('onboarding')}>
          <Icon className="mr-1">
            <Home />
          </Icon>
          {t('backend:getting_started')}
        </Link>
      )}
      {!charity.onboarding && (
        <Link href={routes.dashboard_page()} className={getClassNames('dashboard')}>
          <Icon className="mr-1">
            <Compass />
          </Icon>
          {t('backend:dashboard')}
        </Link>
      )}
      <Link href={routes.projects_page()} className={getClassNames('settings')}>
        <Icon className="mr-1">
          <Settings />
        </Icon>
        {t('backend:settings')}
      </Link>
      <Link href={routes.campaigns_page()} className={getClassNames('campaigns')}>
        <Icon className="mr-1">
          <Users />
        </Icon>
        {t('backend:campaigns')}
      </Link>
      <Link href={routes['donations_page']()} className={getClassNames('donations')}>
        <Icon className="mr-1">
          <Heart />
        </Icon>
        {t('backend:donations')}
      </Link>
      <Link href={routes['embeds_page']()} className={getClassNames('embeds')}>
        <Icon className="mr-1">
          <Code />
        </Icon>
        {t('backend:embeds')}
      </Link>
    </div>
  );
}

